import { z } from "zod";

import { normalizeInstagramHandle } from "@/pages/tina/sites/lib/instagram-handle";

/** Instagram username charset. */
export const HANDLE_RE = /^[a-z0-9._]+$/;

/**
 * `sites.name` is the PK and a path segment in `/sites/{name:path}`, so no
 * slashes or whitespace. Dash is allowed for the `afaslive-instagram` pattern
 * (an IG site coexisting with a same-named web site).
 */
export const SITE_NAME_RE = /^[a-z0-9._-]+$/;

export const siteCreateSchema = z.object({
  handle: z
    .string()
    .min(1, "Instagram handle is required")
    .refine(
      (v) => HANDLE_RE.test(normalizeInstagramHandle(v)),
      "Enter an Instagram handle or profile URL, e.g. @alaska.ath",
    ),
  name: z
    .string()
    .min(1, "Site name is required")
    .regex(
      SITE_NAME_RE,
      "Lowercase letters, digits, dot, underscore and dash only",
    ),
  country_code: z.string().length(2, "Pick a country"),
  city: z.string().min(1, "City is required"),
  site_groups: z.array(z.string()),
  enabled: z.boolean(),
});

export type SiteCreateFormType = z.infer<typeof siteCreateSchema>;
